import axios from 'axios';
import Tokens from "./TokenService";

const baseURL = process.env.VUE_APP_API_URL;

function addAccessToken(request) {
    let accessToken = Tokens.getLocalAccessToken();

    if (accessToken !== null) {
        request.headers.Authorization = `Bearer ${accessToken}`;
    }

    return request;
}

export default () => {
    const instance = axios.create({
        baseURL,
        timeout: 10000,
        headers: {'Accept': 'application/json'},
    });

    instance.interceptors.request.use(addAccessToken);

    instance.interceptors.response.use(
        request => request,
        error => {
            // check network error
            /* if (error.response === undefined) {
                 error.response = {status: 0}; // add new field networkErr
             }*/

            if (error.response.data) {
                console.log('😱', error.response.data)
            }

            return Promise.reject(error);
        }
    );

    instance.interceptors.response.use(
        request => request,
        async error => {

            if (error.response.status === 401) {
                Tokens.cleanData();
                window.location.reload()
            }

            return Promise.reject(error); // это не ошибка доступа

        }
    );

    return instance;
}


